import React, { PropTypes } from 'react';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import { ADMIN_ROOT } from 'common/variables';
import AdminMessageAction from 'admin/containers/message_dropdown';

/**
 * Stream message.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const Message = ({ message, user, location, wrapup, wrapupStep }) => {
  const { id, body, author, attachment } = message;
  const isAuthor = author && author.id * 1 === user.id * 1;
  const isAdmin = location.pathname.indexOf(ADMIN_ROOT) !== -1;
  const authorName = author ? author.username : 'crowdspring';

  return (
    <div className={classnames("message", { internal: message.internal })}>
      { isAdmin && <AdminMessageAction message={message} wrapup={wrapup} wrapupStep={wrapupStep} /> }

      <label htmlFor="message" className="author-username">
        { isAuthor ? 'You' : authorName}
      </label>

      {attachment && <div className="attachment-info">
        Uploaded: <a
          href={attachment.file}
          target="_blank"
          rel="noopener noreferrer"
        >
          {attachment.filename}
        </a>
      </div>}

      <div className="message-body" dangerouslySetInnerHTML={{ __html: body }} />
    </div>);
};

Message.propTypes = {
  message: PropTypes.object,
  user: PropTypes.object,
  location: PropTypes.object,
  wrapup: PropTypes.object,
  wrapupStep: PropTypes.string,
};

export default withRouter(Message);



// WEBPACK FOOTER //
// ./common/components/message.jsx